
export class BOOdontologyRadiologicExamPatient  {
  id:number;
  tempId?:string;
  personId:number;
  itemType:string;
  itemName:string;
  details?:string;
}
